// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__uuXhu","menuButton__text--crop":"MenuButton_menuButton__text--crop__sHRuC","menuButton--selected":"MenuButton_menuButton--selected__mwYwB"};